/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hg_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which algorithm should I use?`)
};

const es_hg_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué algoritmo debo usar?`)
};

const de_hg_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welchen Algorithmus sollte ich verwenden?`)
};

const nl_hg_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welk algoritme moet ik gebruiken?`)
};

const fr_hg_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel algorithme dois-je utiliser ?`)
};

const it_hg_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quale algoritmo dovrei usare?`)
};

const pt_br2_hg_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual algoritmo devo usar?`)
};

const pt_hg_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual algoritmo devo utilizar?`)
};

const ja_hg_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どのアルゴリズムを使うべきですか?`)
};

const zh_hg_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我应该使用哪种算法？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hg_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hg_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hg_faq2_q", locale)
	if (locale === "en") return en_hg_faq2_q(inputs)
	if (locale === "es") return es_hg_faq2_q(inputs)
	if (locale === "de") return de_hg_faq2_q(inputs)
	if (locale === "nl") return nl_hg_faq2_q(inputs)
	if (locale === "fr") return fr_hg_faq2_q(inputs)
	if (locale === "it") return it_hg_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_hg_faq2_q(inputs)
	if (locale === "pt") return pt_hg_faq2_q(inputs)
	if (locale === "ja") return ja_hg_faq2_q(inputs)
	return zh_hg_faq2_q(inputs)
};